import React, { useContext } from 'react'
import { Box, Skeleton } from '@mui/material'
import ChooseTypeCard from './ChooseTypeCard'
import { PageNumberContext } from './PageNumberContext'
import { useForm } from 'react-final-form'
import { useGetIntegrationQuery } from '../../../api/integrations'
import { useNavigate } from 'react-router-dom'
import { parseJwt } from '../../../heplers'

export default function FirstPageForm({ input }) {
  const { setPage } = useContext(PageNumberContext)
  const form = useForm()
  const { onChange } = input
  const navigate = useNavigate()
  const { data, isLoading } = useGetIntegrationQuery({})
  if (isLoading) {
    return <SkeletonCards />
  }

  const userLocal = JSON.parse(localStorage.getItem('user'))
  const companyId = userLocal?.accessToken ? parseJwt(userLocal?.accessToken)?.companyId : null
  const specialCompanyIds = [
    '2ffd7fc7-6d0f-48b6-94c2-1aab115f1ae8',
    '34e38ecc-f011-404d-804e-89e68c4f6ce4',
    'a1cda97a-6d35-4c26-bea1-6b9709463102',
    'bc7aed14-4739-4d18-8dcb-8919cbec900d',
    '424fe594-2c09-42bc-8164-1d369330ad88',
    'd475bcad-b655-4052-a5b2-2ea2cfcd1ab8',
    'cba151f1-abae-44b5-ab64-71f6cec9af14', // Cyberly QA
    'bb5f3b0a-7f19-4cc4-8650-6162af8a81fc', // Glencore 1
    'd7f8b78c-faf8-4395-b069-7db65b66576a' // Glencore 2
  ]

  const isSlackEnabled = data?.some(i => i?.type === 'SLACK_SIMULATION') && data?.some(i => i?.type === 'SLACK')
  const isAiEmailEnabled = specialCompanyIds.includes(companyId)

  const config = [
    {
      type: 'AUTOMATED_EMAIL',
      title: 'Auto-Selected Email Template',
      description: 'AI selects the best existing template from our database based on previous user simulation results',
      isAI: true,
      onClick: () => {
        onChange('AUTOMATED_EMAIL')
        setPage(2)
      }
    },
    {
      type: 'MANUAL_EMAIL',
      title: 'Custom Email',
      description: 'Choose a template or create a phishing email manually from scratch',
      isAI: false,
      onClick: () => {
        onChange('MANUAL_EMAIL')
        setPage(2)
      }
    },
    {
      type: 'AUTOMATED_AI_EMAIL',
      title: 'Fully AI-Generated Email',
      description: 'AI writes a phishing email from scratch based on past user mistakes and tools used in your company',
      isAI: true,
      isCanEnabled: !isAiEmailEnabled,
      isDisabled: !isAiEmailEnabled,
      onClick: () => {
        if (isAiEmailEnabled) {
          onChange('AUTOMATED_AI_EMAIL')
          setPage(2)
        }
      }
    },
    {
      type: 'SMS',
      title: 'SMS Message',
      description: 'Send a phishing test message as a text to mobile phones',
      isAI: false,
      isCanEnabled: false,
      onClick: () => {
        onChange('SMS')
        input?.value === 'SLACK' && form.change('metadata', {})
        setPage(2)
      }
    },
    {
      type: 'DEEP_FAKE',
      title: 'Deepfake Call (AI-Generated)',
      description: 'Send a simulated phone call using a bot with an AI-generated voice and script',
      isAI: true,
      isCanEnabled: false,
      onClick: () => {
        input.value !== 'DEEP_FAKE' && form.change('metadata', {})
        onChange('DEEP_FAKE')
        setPage(2)
      },
      isDisabled: false
    },
    {
      type: 'SLACK',
      title: 'Slack Message',
      description: 'Send a phishing test message to selected users via Slack',
      isAI: false,
      isCanEnabled: !isSlackEnabled,
      onEnableClick: () => {
        navigate('/settings/plugins#communication-tools')
      },
      isDisabled: !isSlackEnabled,
      onClick: () => {
        if (isSlackEnabled) {
          onChange('SLACK')
          input.value === 'SMS' && form.change('metadata', {})
          setPage(2)
        }
      }
    },
    {
      type: 'WHATSAPP',
      title: 'WhatsApp Message',
      description: 'Send a phishing test message to selected users via WhatsApp',
      isAI: false,
      isCanEnabled: true,
      onClick: () => {},
      isDisabled: true
    }
  ]

  return (
    <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} flexWrap={'wrap'} rowGap={'12px'}>
      {config.map((item, index) => (
        <ChooseTypeCard key={index} {...item} />
      ))}
    </Box>
  )
}

const SkeletonCards = () => {
  return (
    <>
      {[1, 2, 3, 4, 5, 6].map((item, index) => (
        <Box
          key={index}
          sx={{
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            mb: 1.5,
            height: '100px'
          }}
        >
          <Skeleton variant='text' width='40%' />
          <Skeleton variant='text' width='70%' />
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Skeleton variant='text' width='25%' />
            <Skeleton variant='rectangular' width={80} height={36} />
          </Box>
        </Box>
      ))}
    </>
  )
}
